export const supportsBannerImage = (mechanic: string) => [
  'spend_and_get',
  'spend_and_get_percent',
  'cashback_percent',
  'cashback_money',
]
  .includes(mechanic || '')